export default __webpack_public_path__ + "locales/si/Payments.json?hash=72263d5ce1effc8066030533fc244cb3";